/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint, ZodTypes } from '../index';
import { z } from '../zod';

export const GetAuthenticationLoginOptions = {
  id: 'authentication.login-options.get',
  tag: 'Authentication',
  summary: 'Login Options',
  description: 'Retrieve the login options for an email',
  method: 'get',
  route: () => `/authentication/login-options`,
  request: { query: z.strictObject({ email: z.string().email() }) },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.discriminatedUnion('type', [
            z.strictObject({
              type: z.literal('basic'),
            }),
            z.strictObject({
              type: z.literal('oauth2'),
              provider: ZodTypes.OAuth2Providers,
            }),
            z.strictObject({
              type: z.literal('oidc'),
              organizationId: ZodTypes.Id,
              organizationName: z.string(),
              thumbnail: z.string(),
            }),
            z.strictObject({
              type: z.literal('none'),
              organizations: z.array(
                z.strictObject({
                  id: ZodTypes.Id,
                  name: ZodTypes.KubernetesIdentifier,
                  thumbnail: z.string(),
                }),
              ),
            }),
          ]),
        },
      },
    },
  },
} as const satisfies Endpoint;
